import { render, staticRenderFns } from "./ConsultaUnica.vue?vue&type=template&id=fef1473e&"
import script from "./ConsultaUnica.vue?vue&type=script&lang=js&"
export * from "./ConsultaUnica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports